export const formatDate = (unformattedDate: string) => {
  const date = new Date(unformattedDate);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours || 12;
  const hoursStr = String(hours).padStart(2, '0');

  return `${day}/${month}/${year} ${hoursStr}:${minutes}:${seconds} ${ampm}`;
};

export const applyDateRangeFilter = (
  filters: any[],
  dateFieldName: string,
  dateRange: string[],
  dateFormat: string = 'DD-MM-YYYY'
): any[] => {
  if (filters.flat(3).includes(dateFieldName)) {
    return filters;
  }

  const dateFilters = [
    [dateFieldName, '>=', toISOLocal(getDate(dateRange[0], dateFormat).toDate())],
    'and',
    [dateFieldName, '<=', toISOLocal(getDate(dateRange[1], dateFormat).endOf('day').toDate())]
  ];

  if (filters.length === 0) {
    return dateFilters;
  }

  const hasLogicalOperator = ['and', 'or'].some((operation) => filters.includes(operation));

  if (!hasLogicalOperator || filters.includes('or')) {
    return [filters, 'and', dateFilters];
  }

  return [...filters, 'and', dateFilters];
};
